/**
 * Name: update playlist
 * Author: @Gaurav
 * Date: 21-07-2021
 */
export default function reducer(
  state = {
    status: 'uninitiated',
    result: {},
  },
  action
) {
  switch (action.type) {
    case 'UPDATE_PLAYLIST_INITIATED': {
      return { ...state, status: 'initiated' };
    }
    case 'UPDATE_PLAYLIST_SUCCESS': {
      return { ...state, status: 'success', result: action.payload };
    }
    case 'UPDATE_PLAYLIST_FAILED': {
      return { ...state, status: 'failed', result: action.payload };
    }
    default: {
      return state;
    }
  }
}
